<template>
  <ul class="tree-node" :class="{ 'tree-node--root': depth === 0 }">
    <li
      v-for="(comp, idx) in components"
      :key="comp.id"
      class="tree-node__item"
      :class="{
        'tree-node__item--last': idx === components.length - 1,
        'tree-node__item--expanded': comp.hasChildren && expandedIds.includes(comp.id)
      }"
    >
      <div
        class="tree-node__row"
        :class="{
          'tree-node__row--selected': selectedId && selectedId === comp.id,
          'tree-node__row--branch': comp.hasChildren,
          'tree-node__row--leaf': !comp.hasChildren
        }"
        @click="onComponentClick(comp)"
      >
        <span v-if="comp.hasChildren" class="tree-node__toggle">
          <font-awesome-icon
            :icon="chevronIcon"
            class="tree-node__chevron"
            :class="{ 'tree-node__chevron--open': expandedIds.includes(comp.id) }"
          />
        </span>
        <span v-else class="tree-node__dot"></span>
        <span class="tree-node__label">{{ comp.componentDescription || comp.name }}</span>
      </div>
      <component-tree-node
        v-if="comp.hasChildren && expandedIds.includes(comp.id) && comp.children && comp.children.length"
        :components="comp.children"
        :expanded-ids="expandedIds"
        :selected-id="selectedId"
        :chevron-icon="chevronIcon"
        :depth="depth + 1"
        @toggle="$emit('toggle', $event)"
      />
    </li>
  </ul>
</template>

<script>
import Vue from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default Vue.extend({
  name: "ComponentTreeNode",
  components: { FontAwesomeIcon },
  props: {
    components: { type: Array, default: () => [] },
    expandedIds: { type: Array, default: () => [] },
    selectedId: { type: String, default: null },
    chevronIcon: { type: Object, default: null },
    depth: { type: Number, default: 0 }
  },
  methods: {
    onComponentClick(comp) {
      this.$emit("toggle", comp);
    }
  }
});
</script>
